import { useMemo } from 'react';

import { useIsDeleteUserEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useRemoveUserSectionSettings: UseMainUIFeatureSettings<'removeUserSection'> = (options) => {
  const removeUserSectionOverrides = options?.overrides?.removeUserSection;

  const viewerCanRemoveUser = useIsDeleteUserEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: viewerCanRemoveUser,
      ...removeUserSectionOverrides,
    }),
    [removeUserSectionOverrides, viewerCanRemoveUser]
  );
};
